import * as React from "react";
import { SVGProps } from "react";

const WarningTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <path
      fill="#F0B02A"
      d="M12 14.044a.562.562 0 0 1-.557-.557V9.769c0-.304.253-.557.557-.557.305 0 .558.253.558.557v3.718a.562.562 0 0 1-.558.557ZM12 16.46c-.044 0-.096-.007-.148-.015a.471.471 0 0 1-.134-.044.564.564 0 0 1-.134-.067l-.112-.09a.782.782 0 0 1-.215-.527c0-.193.082-.387.215-.528l.112-.09a.564.564 0 0 1 .134-.066.471.471 0 0 1 .134-.045.636.636 0 0 1 .29 0 .448.448 0 0 1 .14.045c.045.015.09.037.135.067l.111.09a.782.782 0 0 1 .216.527.782.782 0 0 1-.216.528l-.111.089a.564.564 0 0 1-.134.067.448.448 0 0 1-.141.044.914.914 0 0 1-.142.015Z"
    />
    <path
      fill="#F0B02A"
      d="M16.505 19.553h-9.01c-1.45 0-2.557-.528-3.122-1.48-.558-.951-.483-2.178.223-3.449L9.1 6.521c.743-1.338 1.77-2.074 2.9-2.074s2.155.736 2.899 2.074l4.505 8.11c.706 1.272.788 2.491.223 3.45-.565.944-1.673 1.472-3.123 1.472ZM12 5.562c-.698 0-1.382.535-1.925 1.502l-4.498 8.11c-.505.907-.587 1.74-.238 2.342.35.602 1.123.93 2.164.93h9.01c1.04 0 1.806-.328 2.163-.93.357-.602.268-1.427-.238-2.342l-4.512-8.11c-.543-.967-1.227-1.502-1.926-1.502Z"
    />
  </svg>
);
export default WarningTriangle;
